import type { Components, Theme } from "@mui/material/styles";

export const MuiChip: Components<Theme>["MuiChip"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      fontWeight: 700,
    }),
    sizeSmall: {
      fontSize: "0.625rem",
      height: 24,
    },
    sizeMedium: {
      fontSize: "0.8125rem",
      height: 40,
    },
  },
};
